package com.flowyride.data.account

/** Where native apps keep the session token between launches. */
interface TokenStore {
    fun read(): String?
    fun write(token: String?)
}

class InMemoryTokenStore(private var token: String? = null) : TokenStore {
    override fun read(): String? = token
    override fun write(token: String?) {
        this.token = token
    }
}

/** Persistent store on Android/iOS; in memory on the web, where the session is an HttpOnly cookie. */
expect fun platformTokenStore(): TokenStore

/**
 * True on the web: the server keeps the session in an HttpOnly cookie that scripts cannot read,
 * so a script injected in the page could not steal it.
 */
expect val platformUsesSessionCookie: Boolean
